export const CONTEXTUAL_INSIGHTS_REPORT_ID = 'contextual-insights';
